<template>
  <b-card>
    <div class="mb-1">
      <i class="ml-2 fa fa-handshake fa-lg"></i><span class="h6 ml-2">{{ $t('menu.agreements.index') }}</span>
    </div>
    <hr class="mt-1 mb-1">
    <Table></Table>
  </b-card>
</template>

<script>
import Table from '@/components/Dashboard/Views/excmagreement/Table'

export default {
  name: 'ClientSlaAgreements',
  components: {
    Table
  }
}
</script>

<style scoped>

</style>
